// test715
(715 && 0);
